module.exports = __webpack_public_path__ + "static/media/no-img.c854966e.jpg";